import { z } from 'zod';

export const ThemeFontSchema = z.enum(['sans','serif','mono']);

export type ThemeFontType = `${z.infer<typeof ThemeFontSchema>}`

export default ThemeFontSchema;
